import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import logo from '../assets/Logo.jpg';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        background: 'linear-gradient(135deg, #1B5E20 0%, #2E7D32 100%)',
        color: '#fff',
        pt: 5,
        pb: 3,
        px: 3,
      }}
    >
      {/* Top section */}
      <Box
        sx={{
          maxWidth: 900,
          mx: 'auto',
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'space-between',
          alignItems: { xs: 'center', sm: 'flex-start' },
          gap: 3,
          pb: 4,
          borderBottom: '1px solid rgba(255,255,255,0.15)',
        }}
      >
        {/* Logo + Name */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box
            component="img"
            src={logo}
            alt="Logo"
            sx={{
              width: 48,
              height: 48,
              borderRadius: '50%',
              border: '2px solid rgba(255,255,255,0.35)',
              objectFit: 'cover',
            }}
          />
          <Box>
            <Typography
              sx={{
                fontFamily: '"Playfair Display", serif',
                fontWeight: 600,
                fontSize: '1.05rem',
                color: '#fff',
                lineHeight: 1.2,
              }}
            >
              Heilpraktikerin
            </Typography>
            <Typography
              sx={{
                fontFamily: '"Playfair Display", serif',
                fontStyle: 'italic',
                fontSize: '0.9rem',
                color: '#D4A843',
                lineHeight: 1.2,
              }}
            >
              Sylwia Spiller
            </Typography>
          </Box>
        </Box>

        {/* Tagline */}
        <Typography
          sx={{
            fontFamily: '"Playfair Display", serif',
            fontStyle: 'italic',
            color: 'rgba(255,255,255,0.7)',
            fontSize: '0.95rem',
            textAlign: { xs: 'center', sm: 'right' },
            maxWidth: 280,
            lineHeight: 1.6,
          }}
        >
          „Die Natur heilt – ich begleite Sie auf dem Weg."
        </Typography>
      </Box>

      {/* Bottom Links */}
      <Box
        sx={{
          maxWidth: 900,
          mx: 'auto',
          pt: 3,
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <Typography sx={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.82rem' }}>
          © {year} Sylwia Spiller · Heilpraktikerin · Berlin
        </Typography>
        <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap', justifyContent: 'center' }}>
          {[
            { label: 'Kontakt', href: '/kontakt' },
            { label: 'Impressum', href: '/impressum' },
            { label: 'Datenschutz', href: '/datenschutzerklarung' },
          ].map(({ label, href }) => (
            <Link
              key={label}
              href={href}
              sx={{
                color: 'rgba(255,255,255,0.65)',
                fontSize: '0.85rem',
                textDecoration: 'none',
                '&:hover': { color: '#D4A843' },
                transition: 'color 0.2s ease',
              }}
            >
              {label}
            </Link>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
